import clsx from "clsx";
import { LabelHeaderCell } from "../HeaderCell/LabelHeaderCell";
import { AccountLabel } from "@/entities/Labeling/Account.model";
import { LabelItem } from "../../LabelItem";
import { ACCOUNT_LIST } from "@/features/Labeling/constants/labeling.constants";
import { AccountAppearanceState } from "@/features/Labeling/Labeling.types";

export const AccountLabelColDef = {
    headerName: "Account Label",
    colId: "label",
    pinned: "left" as const,
    width: 300,
    suppressSizeToFit: true,
    suppressHeaderMenuButton: true,
    sortable: false,
    headerComponentParams: {
        innerHeaderComponent: LabelHeaderCell,
    },
    valueGetter: (params) => {
        return params.data.account?.label || params.data.rowHeader;
    },
};

export const AccountLabelCellRenderer = ({
    label,
    showReadableLabel,
    appearanceState,
    canChangeAccount,
}: {
    showReadableLabel: boolean;
    appearanceState: AccountAppearanceState;
    canChangeAccount: boolean;
    label?: AccountLabel | null;
}) => {
    if (!label)
        return (
            <div
                className={clsx(
                    "size-full",
                    canChangeAccount ? "cursor-default" : "cursor-pointer",
                )}
            />
        );

    return (
        <div
            className={clsx(
                "flex  size-full items-center justify-between",
                appearanceState === AccountAppearanceState.DEFAULT
                    ? "opacity-100"
                    : "opacity-50",
                canChangeAccount ? "cursor-default" : "cursor-pointer",
            )}
        >
            <LabelItem
                className="w-full"
                label={ACCOUNT_LIST[label]}
                prettify={showReadableLabel}
                dot
            />
        </div>
    );
};
